import {
  ActiveArticle,
  useAnalyzeClustering,
} from '@/features/analyze/hooks/useAnalyzeClustering';
import { useEffect, useRef } from 'react';
// @ts-expect-error 型定義がないので一旦無視する
import { FoamTree as FoamTreeImpl } from '@carrotsearch/foamtree';

const foamTreeOption = {
  pixelRatio: window.devicePixelRatio || 1,
  relaxationVisible: true,
  groupBorderWidth: 1,
  groupBorderWidthScaling: 0.4,
  rolloutEasing: 'squareInOut',
  rolloutScalingStrength: -0.3,
  rolloutRotationStrength: 0,
  pullbackEasing: 'squareInOut',
  pullbackScalingStrength: -0.3,
  pullbackRotationStrength: 0,
  pullbackPolygonDelay: 0.1,
  fadeDuration: 0,
  groupFillType: 'plain',
};

export type GroupItem = {
  id: string;
  label: string;
  doc: ActiveArticle;
};

type FoamTreeViewProps = {
  data: ReturnType<typeof useAnalyzeClustering>['formattedTreemapData'];
  onSelectTarget: (e: { group?: Partial<GroupItem> }) => void;
};

export const FoamTreeView = ({ data, onSelectTarget }: FoamTreeViewProps) => {
  const element = useRef(null);
  const foamtree = useRef<typeof FoamTreeImpl>(null);

  const foamTreeDataSignature = JSON.stringify(
    data.flatMap((d) => d.groups.map((g) => g.doc.code)).sort()
  );

  useEffect(() => {
    foamtree.current = new FoamTreeImpl({
      ...foamTreeOption,
      element: element.current,
      dataObject: { groups: data },
    });

    window.addEventListener('orientationchange', foamtree.current.resize);
    window.addEventListener('resize', foamtree.current.resize);
    foamtree.current.set('onGroupDoubleClick', onSelectTarget);

    return () => {
      if (!foamtree.current) return;
      window.removeEventListener('orientationchange', foamtree.current.resize);
      window.removeEventListener('resize', foamtree.current.resize);

      foamtree.current.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foamTreeDataSignature]);

  return <div id="visualization" ref={element} className="size-full"></div>;
};
